<template lang="pug">
  v-container.layout(fluid)
    v-layout(column wrap align-center justify-center)
      v-progress-circular(
        :size='80'
        :width='8'
        color='primary'
        indeterminate
      )
      span Logging you in...
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'MarketingSSO',
  async created() {
    await this.getMarketingToken();
    this.redirect();
  },
  computed: {
    ...mapGetters('authentication', ['marketingToken']),
  },
  methods: {
    ...mapActions('authentication', ['getMarketingToken']),
    redirect() {
      if(this.marketingToken) {
        const evocalizeUrlSSO = process.env.VUE_APP_EVOCALIZE_SSO_URL.concat(this.marketingToken);
        window.location.href = evocalizeUrlSSO;
      }
    },
  },
}
</script>
